import { css } from 'lit';

export const styles = [
  css`
    :host {
      --default-rem-px-count: 16;
      --column-gap: calc(32rem / var(--default-rem-px-count));
    }

    .header {
      padding-bottom: calc(42rem / var(--default-rem-px-count));
    }

    h1 {
      font-size: calc(32rem / var(--default-rem-px-count));
      font-weight: 500;
      letter-spacing: -1.12;
      line-height: calc(40rem / var(--default-rem-px-count));
    }

    h4 {
      font-size: calc(18rem / var(--default-rem-px-count));
      font-weight: 400;
      letter-spacing: -0.54;
      line-height: calc(24rem / var(--default-rem-px-count));
    }

    .page-wrapper {
      margin: 0 auto;
      max-width: 1440px;
      padding: 2rem 1rem;
      display: flex;
      flex-direction: column;
    }

    .form-wrapper {
      display: flex;
      flex-direction: column;
    }

    form {
      display: flex;
      flex-direction: column;
      max-width: calc(670rem / var(--default-rem-px-count));
    }

    .input-row {
      display: flex;
      flex-direction: column;
      column-gap: var(--column-gap);
      row-gap: calc(20rem / var(--default-rem-px-count));
      padding-bottom: calc(21rem / var(--default-rem-px-count));
    }

    .input-wrapper {
      flex-grow: 1;
      border: 1px solid;
      position: relative;
    }

    .reference-img-wrapper {
      margin-top: calc(20rem / var(--default-rem-px-count));
      max-width: 400px;
    }

    .reference-img-wrapper img {
      width: 100%;
      max-height: calc(600rem / var(--default-rem-px-count));
      /* some images have transparencies a light border solves this */
      border: 1px solid #f0f0f0;
    }

    /* Override browser defaults */
    .input-wrapper input,
    .input-wrapper textarea {
      -webkit-appearance: none;
      outline: none;
      box-shadow: none;
      border: none;
      padding: 0;
    }

    .input-wrapper input,
    .input-wrapper textarea {
      width: calc(100% - calc(16rem / var(--default-rem-px-count)));
      height: calc(44rem / var(--default-rem-px-count));
      margin-left: calc(16rem / var(--default-rem-px-count));
      padding-top: calc(4rem / var(--default-rem-px-count));
      display: block;
    }

    .input-wrapper textarea {
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    label.input-label {
      position: absolute;
      top: calc(14rem / var(--default-rem-px-count));
      left: calc(16rem / var(--default-rem-px-count));
      transition: 0.4s ease all;
      font-size: calc(14rem / var(--default-rem-px-count));
      font-weight: 400;
      letter-spacing: -0.21;
      line-height: calc(20rem / var(--default-rem-px-count));
      pointer-events: none;
    }

    input:focus ~ label.input-label,
    input ~ label.input-label.valid,
    textarea:focus ~ label.input-label,
    textarea ~ label.input-label.valid.touched {
      font-size: calc(10rem / var(--default-rem-px-count));
      top: 0px;
    }

    label.input-label.invalid.touched {
      color: red;
      top: 0px;
      font-size: calc(10rem / var(--default-rem-px-count));
    }

    input.visited ~ label.input-label {
      color: red;
    }

    textarea {
      resize: vertical;
      font-family: inherit;
      min-height: calc(100rem / var(--default-rem-px-count));
    }

    textarea::-webkit-input-placeholder {
      padding-top: 10px;
    }

    #uploads-wrapper {
      padding-bottom: calc(42rem / var(--default-rem-px-count));
    }

    .upload-trigger {
      display: flex;
      cursor: pointer;
      width: fit-content;
    }

    .upload-trigger img {
      padding-right: calc(14rem / var(--default-rem-px-count));
    }

    .upload-trigger p {
      font-size: 16px;
      letter-spacing: -0.24px;
      line-height: 24px;
      color: #222222;
      width: fit-content;
    }

    .fine-print {
      font-size: calc(12rem / var(--default-rem-px-count));
    }

    #selectedFile {
      margin-left: calc(20rem / var(--default-rem-px-count));
    }

    #selectedFiles span {
      display: flex;
      flex-direction: row;
      align-items: baseline;
    }

    #selectedFiles span > p {
      margin-bottom: 0;
    }

    .remove-file {
      font-size: calc(10rem / var(--default-rem-px-count));
      margin-left: calc(10rem / var(--default-rem-px-count));
      cursor: pointer;
    }

    .validation-prompt {
      color: red;
    }

    .cta-btn {
      width: 50%;
    }

    .success-wrapper {
      display: flex;
      flex-direction: row;
      max-width: calc(670rem / var(--default-rem-px-count));
      column-gap: var(--column-gap);
    }

    .success-cta-btn {
      min-width: calc((100% - (2 * var(--column-gap))) / 3);
    }

    /* Hide arrows on number inputs */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Same as above but Firefox wants to be special */
    input[type='number'] {
      -moz-appearance: textfield;
    }

    @media (min-width: 600px) {
      .page-wrapper {
        padding: 3rem 2rem;
      }

      .form-wrapper {
        gap: calc(40rem / var(--default-rem-px-count));
      }

      .reference-img-wrapper {
        margin-top: 0;
      }

      .input-row {
        flex-direction: row;
        column-gap: calc(32rem / var(--default-rem-px-count));
        padding-bottom: calc(21rem / var(--default-rem-px-count));
        row-gap: 0;
      }

      .cta-btn {
        width: calc((100% - (2 * var(--column-gap))) / 3);
      }
    }

    @media (min-width: 1024px) {
      .form-wrapper {
        flex-direction: row;
        gap: calc(120rem / var(--default-rem-px-count));
      }
    }
  `,
];
